import Select, { SelectOption, SelectProps } from "components/Select";

import { cx } from "utils";

type LabelledSelectProps<T> = {
  label: string;
  buttonTestId?: string;
} & SelectProps<T>;

export function LabelledSelect<T extends SelectOption<any>>(
  {
    label,
    value,
    options,
    onChange,
    className,
    size = "MD",
    buttonTestId
  }: LabelledSelectProps<T>
) {
  const appliedClassName = cx("flex flex-row items-center relative", className);
  return (
    <div className={appliedClassName}>
      <div className="text-nowrap mr-2.5 text-sm text-neutral-700">{label}</div>
      {/* Select's size sets text-base on its inner button, so text size and corners are set on that element. */}
      <Select
        size={ size }
        value={ value }
        options={ options }
        onChange={ onChange }
        buttonTestId={ buttonTestId }
        className="w-full text-nowrap [&_.select-button]:rounded [&_.select-button]:text-sm"
      />
    </div>
  );
}

export default LabelledSelect;
